import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=7dc0dfbb"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports